document.addEventListener("cart:updated", ({detail: { items }}) => {
  // Calculate total quantity
  const totalQuantity = items.reduce((sum, item) => sum + item.quantity, 0);
  
  // Update cart count displays
  document.querySelectorAll('.cart-bubble__text-count')
    .forEach(element => {
      element.textContent = totalQuantity;
      element.classList.remove("hidden");
    });

  document.querySelectorAll('.cart-bubble')
    .forEach(element => {
      element.classList.remove("visually-hidden");
    });
});